<div class="confirm-dialog" fxLayout="column">
  <div fxLayout="row">
    <h3>{{text}}</h3>
  </div>

  <div fxLayout="row">
    <div fxFlex="100">
      <mat-form-field fxFlex="100">
        <mat-label>Powód</mat-label>
        <input [required]="true" matInput placeholder="Powód" [formControl]="reasonControl">
        <mat-error *ngIf="reasonControl.hasError('required')">Musisz podać powód</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex></div>
    <div>
      <button [disabled]="!reasonControl.value" (click)="confirm()" mat-raised-button color="warn"><span> Tak</span></button>
    </div>
    <div>
      <button (click)="decline()" mat-raised-button color="primary" class="confirm-dialog-decline-button"><span> Nie</span></button>
    </div>
  </div>
</div>
